/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IActionContext } from '@msdyn365-commerce/core';
import { removeDiscountCodesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { Cart } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

import { ICartActionResultWithCart } from './cart-action-result';

export default async function removePromoCodes(
    cart: Readonly<Cart | undefined>,
    promoCodes: string[],
    actionContext: IActionContext
): Promise<ICartActionResultWithCart> {
    if (!cart) {
        return { cart: undefined, status: 'FAILED', substatus: 'EMPTYCART' };
    }

    return removeDiscountCodesAsync({ callerContext: actionContext }, cart.Id, promoCodes)
        .then(newCart => {
            return <ICartActionResultWithCart>{ cart: newCart, status: 'SUCCESS' };
        })
        .catch(error => {
            actionContext.telemetry.warning(error);

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- existing error type.
            return <ICartActionResultWithCart>{ cart: undefined, status: 'FAILED', errorDetails: { LocalizedMessage: error.message } };
        });
}
